const state = {
  currentProjectName: '',
  currentProjectId: 0,
  currentProjectList: []
}

const mutations = {
  SET_PROJECT_NAME: (state, projectName) => {
    state.currentProjectName = projectName
  },

  SET_PROJECT_ID: (state, projectId) => {
    state.currentProjectId = projectId || 0
  },

  SET_PROJECT_LIST: (state, projectList) => {
    state.currentProjectList = projectList
  }
}

const actions = {
  async setProject({ commit, state }, project) {
    commit('SET_PROJECT_ID', project.id)
    commit('SET_PROJECT_NAME', project.projectName)
  },

  async setProjectList({ commit, state }, projectList) {
    commit('SET_PROJECT_LIST', projectList)
  },

  async reSetProject({ commit, state }) {
    commit('SET_PROJECT_ID', '')
    commit('SET_PROJECT_NAME', '')
    commit('SET_PROJECT_LIST', [])
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

